var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Connection } from "@solana/web3.js";
import { getProgram } from "./getProgram.obj";
import { isVersionedTransaction } from "@solana/wallet-adapter-base";
export function checkOptionSend(Data) {
    var clusterOrUrl = Data.clusterOrUrl, commitment = Data.commitment, connection = Data.connection, retryDelay = Data.retryDelay, skipConfirmation = Data.skipConfirmation, skipSimulation = Data.skipSimulation, prioritizationFee = Data.prioritizationFee;
    if (!skipSimulation)
        skipSimulation = false;
    if (!skipConfirmation)
        skipConfirmation = false;
    if (!commitment)
        commitment = "confirmed";
    if (!retryDelay)
        retryDelay = 5000;
    if (connection && clusterOrUrl) {
    }
    else if (!connection && clusterOrUrl)
        connection = new Connection(clusterOrUrl);
    else if (!clusterOrUrl && connection)
        clusterOrUrl = connection.rpcEndpoint;
    else
        throw {
            blockchain: "solana",
            status: "error",
            message: "clusterOrUrl or connection is required",
        };
    return {
        clusterOrUrl: clusterOrUrl,
        commitment: commitment,
        connection: connection,
        retryDelay: retryDelay,
        skipConfirmation: skipConfirmation,
        skipSimulation: skipSimulation,
        prioritizationFee: prioritizationFee,
    };
}
export function checkEnvOpts(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var clusterOrUrl, anyProgram, prioritizationFee, programId, idl, program;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clusterOrUrl = Data.clusterOrUrl, anyProgram = Data.program, prioritizationFee = Data.prioritizationFee, programId = Data.programId, idl = Data.idl;
                    if (!(anyProgram && clusterOrUrl)) return [3 /*break*/, 1];
                    program = anyProgram;
                    return [3 /*break*/, 4];
                case 1:
                    if (!(!anyProgram && clusterOrUrl)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getProgram({ clusterOrUrl: clusterOrUrl, programId: programId, idl: idl })];
                case 2:
                    // console.log("programId", programId);
                    program = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (!clusterOrUrl && anyProgram) {
                        program = anyProgram;
                        clusterOrUrl = program.provider.connection.rpcEndpoint;
                    }
                    else {
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "clusterOrUrl or program is required",
                        };
                    }
                    _a.label = 4;
                case 4:
                    programId = program.programId.toString();
                    console.log(programId);
                    return [2 /*return*/, {
                            program: program,
                            clusterOrUrl: clusterOrUrl,
                            connection: program.provider.connection,
                            prioritizationFee: prioritizationFee,
                            programId: programId,
                            idl: program.idl,
                        }];
            }
        });
    });
}
export function getMakeArgs(Data) {
    var bids = Data.bids, endDate = Data.endDate, maker = Data.maker, nftMintMaker = Data.nftMintMaker, paymentMint = Data.paymentMint;
    maker = typeof maker === "string" ? maker : maker.publicKey.toString();
    return { bids: bids, endDate: endDate, maker: maker, nftMintMaker: nftMintMaker, paymentMint: paymentMint };
}
export function getTakeArgs(Data) {
    var bid = Data.bid, nftMintTaker = Data.nftMintTaker, swapDataAccount = Data.swapDataAccount, taker = Data.taker, verifyTaker = Data.verifyTaker, signer = Data.signer, n = Data.n, unwrap = Data.unwrap;
    taker = typeof taker === "string" ? taker : taker.publicKey.toString();
    return { bid: bid, nftMintTaker: nftMintTaker, swapDataAccount: swapDataAccount, taker: taker, verifyTaker: verifyTaker, signer: signer, n: n, unwrap: unwrap };
}
export function getClaimSArgs(Data) {
    var signer = Data.signer, swapDataAccount = Data.swapDataAccount;
    signer = typeof signer === "string" ? signer : signer.publicKey.toString();
    return { swapDataAccount: swapDataAccount, signer: signer };
}
export function isVersionedArray(txs) {
    if (txs.length === 0)
        return false;
    return isVersionedTransaction(txs[0]);
}
export function isMakeSArg(Data) {
    if ("endDate" in Data &&
        "maker" in Data &&
        "nftMintMaker" in Data &&
        "paymentMint" in Data &&
        "bids" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function isTakeSArg(Data) {
    if ("taker" in Data && "bid" in Data && "nftMintTaker" in Data && "swapDataAccount" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function isClaimSArg(Data) {
    if ("swapDataAccount" in Data && "signer" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function isUpdateSArg(Data) {
    if ("bids" in Data && "swapDataAccount" in Data && "maker" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function isSetNewTime(Data) {
    if ("newTime" in Data && "swapDataAccount" in Data && "maker" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function isRmBidsArgs(Data) {
    if ("rmBids" in Data && "swapDataAccount" in Data && "maker" in Data) {
        return true;
    }
    else {
        return false;
    }
}
export function whatIs(Data) {
    if (isMakeSArg(Data))
        return "MakeSArg";
    if (isTakeSArg(Data))
        return "TakeSArg";
    if (isClaimSArg(Data))
        return "ClaimSArg";
    if (isUpdateSArg(Data))
        return "UpdateSArgs";
    if (isSetNewTime(Data))
        return "SetNewTime";
    if (isRmBidsArgs(Data))
        return "RmBidArgs";
    return "unknown";
}
